import { Component, Host, Prop, h } from '@stencil/core';
import { formatSmartDate } from '@utils/dateUtils';
import { pluralize } from '@utils/stringUtils';
import { SportslinePickProps } from 'src/types';

@Component({
  tag: 'sportsline-free-expert-pick-selection',
  styleUrl: 'sportsline-free-expert-pick-selection.css',
  shadow: true,
})
export class SportslinePickCard {
  /**
   * The pick to be displayed in the card.
   */
  @Prop() pick: Pick<SportslinePickProps, 'status' | 'createdAt' | 'unit' | 'analysis' | 'gameInfo' | 'selection' | 'isBettable'>;

  private get getUnits() {
    return `${this.pick.unit} ${pluralize(this.pick.unit, 'unit')}`;
  }
  private get getFormattedDate() {
    return formatSmartDate(new Date(this.pick.createdAt), '@');
  }

  render() {
    if (!Boolean(this.pick)) {
      return null;
    }
    return (
      <Host>
        <div class="sportsline-free-expert-pick-selection">
          <sportsline-free-expert-pick-selection-header pick={this.pick} />
          <div class="sportsline-free-expert-pick-selection-content">
            <div class="sportsline-free-expert-pick-selection-content-header">
              <div class="sportsline-free-expert-pick-selection-content-header-header-details">{`Pick Made:  ${this.getFormattedDate}, ${this.getUnits}`}</div>
              <sportsline-chip status={this.pick.status} />
            </div>
            <sportsline-analysis analysis={this.pick.analysis} />
          </div>
        </div>
        <slot></slot>
      </Host>
    );
  }
}
